import React from 'react';
import { Nav, INavLink } from '@fluentui/react/lib/Nav';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { darkBlueTheme } from '../AppGlobals';

interface Props {
    onCloseMenu?: () => void;
}

export const DemoZedXMainMenu: React.FC<Props> = ({ onCloseMenu }) => {

    const goBackWithEnv = (env: "LIVE" | "TEST") => {

        if (onCloseMenu) onCloseMenu();

        let targetUrl = "";

        if (document.referrer) {
            targetUrl = document.referrer;
        } else if (window.history.length > 1) {
            window.history.back();
            return;
        } else {
            return;
        }

        try {
            const url = new URL(targetUrl);
            url.searchParams.set("env", env);
            window.location.href = url.toString();
        } catch {
            window.location.href = targetUrl;
        }
    };

    const navLinks: INavLink[] = [
        {
            name: 'Live Account',
            key: 'live',
            url: '',
            data: { color: '28A745' },
            onClick: () => goBackWithEnv("LIVE")
        },
        {
            name: 'Training Account',
            key: 'training',
            url: '',
            data: { color: 'F59E0B' },
            onClick: () => goBackWithEnv("TEST")
        },
        {
            name: 'Demo Account',
            key: 'demo',
            url: '',
            data: { color: '3399FF' },
            onClick: () => {
                if (onCloseMenu) onCloseMenu();
            }
        }
    ];

    const renderColorIcon = (color: string) => (
        <img
            width="10"
            height="10"
            style={{ marginRight: '8px', borderRadius: '2px' }}
            src={`https://placehold.co/10x10/${color}/${color}`}
        />
    );

    return (
        <ThemeProvider theme={darkBlueTheme}>
            <div style={{ width: '100%' }}>

                {/* Logo */}
                <div style={{ paddingBottom: '25px', paddingLeft: '15px' }}>
                    <img
                        src={`${process.env.REACT_APP_ZedXImagesRoot}/leftnav/LeftMenu-ZedXMainMenu.png`}
                        alt="ZedX"
                        style={{ maxWidth: '100%' }}
                    />
                </div>

                <Nav
                    selectedKey="demo"
                    groups={[{ links: navLinks }]}
                    onRenderLink={(link) => (
                        <span style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                            {renderColorIcon(link.data?.color)}
                            <span>{link.name}</span>
                        </span>
                    )}
                />

            </div>
        </ThemeProvider>
    );
};